import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Card, CardContent, Typography } from '@mui/material';

interface SignupShellProps {
  title: string;
  maxWidth?: number;
  children: ReactNode;
}

/** The public frame shared by every signup page: one h1, one card. */
export function SignupShell({ title, maxWidth = 560, children }: SignupShellProps) {
  const { t } = useTranslation('signup');
  return (
    <Box
      component="main"
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'background.default',
        p: 2,
      }}
    >
      <Card sx={{ maxWidth, width: '100%' }}>
        <CardContent sx={{ p: { xs: 3, sm: 4 } }}>
          <Typography variant="h4" component="h1" fontWeight={700} gutterBottom>
            {title}
          </Typography>
          {children}
          <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 3 }}>
            {t('providerNote')}
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
}
